import { PawPrint, BadgeCheck, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const newShelters = [
  { name: "Schronisko dla Bezdomnych Zwierząt", city: "Katowice" },
  { name: 'Schronisko "Arka" ŁTOZ', city: "Łomża" },
  { name: "Ochota na Kota", city: "Warszawa" },
  { name: "Stowarzyszenie Cztery Łapy", city: "Olecko" },
];

export const InstagramStory4Verified3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top accent bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "6px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 3,
        }}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 56px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <div
            style={{
              fontSize: "180px",
              fontWeight: 800,
              color: "#4E8A6E",
              lineHeight: 0.85,
              textShadow: "0 8px 40px rgba(78,138,110,0.2)",
            }}
          >
            4
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", marginTop: "-4px" }}>
            <BadgeCheck style={{ width: "44px", height: "44px", color: "#4E8A6E" }} />
            <span style={{ fontSize: "46px", fontWeight: 800, color: "#2D5A3D" }}>
              nowe weryfikacje!
            </span>
          </div>
        </div>

        {/* Grid 2x2 */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            alignContent: "center",
          }}
        >
          {newShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "24px",
                padding: "32px 28px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                gap: "12px",
                boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
                border: "2px solid rgba(78,138,110,0.15)",
              }}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #5D9A7D, #4E8A6E)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BadgeCheck style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
              </div>
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: 700,
                  color: "#2D5A3D",
                  lineHeight: 1.2,
                }}
              >
                {shelter.name}
              </span>
              <span style={{ fontSize: "22px", fontWeight: 500, color: "#6B8A7A" }}>
                📍 {shelter.city}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div style={{ textAlign: "center", marginTop: "48px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(78,138,110,0.12)",
              borderRadius: "100px",
              padding: "18px 40px",
              marginBottom: "24px",
            }}
          >
            <Heart style={{ width: "28px", height: "28px", color: "#4E8A6E", fill: "#4E8A6E" }} />
            <span style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D" }}>
              Sprawdź ich potrzeby!
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
